import { Button, Icon } from '@packages/ui/shared';
import { useCallback } from 'react';

import { ssm5ControlStyles, ssm5TextStyles } from '../ssm5.styles';

/** Props for {@link PasteFromClipboardButton}. */
type PasteFromClipboardButtonProps = {
    /** Receives the clipboard text. */
    onPaste: (text: string) => void;
    /** Button label. */
    title: string;
};

/**
 * Small ghost button that reads the clipboard into the field.
 *
 * @param props - {@link PasteFromClipboardButtonProps}
 * @returns the paste button
 */
export function PasteFromClipboardButton({ onPaste, title }: PasteFromClipboardButtonProps) {
    const paste = useCallback(() => {
        navigator.clipboard
            .readText()
            .then(onPaste)
            .catch(() => undefined);
    }, [onPaste]);

    return (
        <Button
            iconRight={<Icon color="blueOne" name="copy" />}
            onPress={paste}
            size="small"
            style={ssm5ControlStyles.smallButton}
            title={title}
            titleStyle={ssm5TextStyles.smallButtonTitle}
            variant="ghost-blue"
        />
    );
}
